import React from 'react';

const SectionHeader = ({ titleRef, subtitleRef, colors }) => {
  return (
    <div className="text-center mb-4">
      <h2 
        ref={titleRef}
        className="fw-bold mb-3 display-5 industry-title animated-title" 
        style={{ color: colors.white }}
      >
        Industries We Served
      </h2>
      <p 
        ref={subtitleRef}
        className="industry-subtitle animated-subtitle"
        style={{ 
          color: colors.white, 
          maxWidth: '800px', 
          margin: '0 auto',
          opacity: '0.9 '
        }}
      >
        Crafting digital experiences that push boundaries and deliver exceptional results
      </p>
    </div>
  );
};

export default SectionHeader;